
export const routerUtils = {
    
    canGoBack : function(){
        return !!window.history.state.back
    }
}